import React from 'react';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { FlatButton } from 'material-ui';

export const SlugLink = ({ id, title, slug, record }) => (
  <Link to={`/${slug}/${get(record, id)}`}>
    <FlatButton primary><span>{get(record, title)}</span></FlatButton>
  </Link>
);

export default SlugLink;
